module.exports = __webpack_public_path__ + "assets/img/hosp-subscribe-banner.e3086dcb.png";